import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute , Router} from '@angular/router';
import { CommonService } from 'src/app/services/common-services/common.service';
@Component({
  selector: 'app-speaker',
  templateUrl: './speaker.component.html',
  styleUrls: ['./speaker.component.scss']
})
export class SpeakerComponent {
  speakerList:any;
  singleSpeaker:any;
  speakerId!:number;
  constructor(
    private location: Location, 
    private route: ActivatedRoute, 
    private router:Router,
    private commonService:CommonService
  ){ }
  ngOnInit(): void {
    
    this.route.params.subscribe((params) => {
      this.speakerId = params['id'];
      if(this.speakerId){
        this.getSpeakers();
      }
    });
  }
  getSpeakers(){
    let apiUrl = 'assets/json/speaker.json';
    this.commonService.getData(apiUrl).subscribe({
      next :(res:any) =>{
        this.speakerList = res.data;
        if(this.speakerId){
          this.getSpeakerInfo(this.speakerId);
        }
      }
    })
  }
  getSpeakerInfo(speakerId:number){
    this.singleSpeaker = this.speakerList?.find((speaker:any) => speaker.id == speakerId);
  }
  goBack(){
    this.location.back();
  }
  viewSpeakerDetail(speakerId:number){
    this.router.navigate([`/speaker/${speakerId}`]);
  }
}
